export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["खोज"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["आप डेमो मोड में हैं। शेष राशि और लेनदेन प्रशिक्षण के लिए हैं।"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["कार्य कैबिनेट में जाएं"])}
}